import { ReactComponent as mLogo } from "./logo/logo.svg";
import farmer1 from "./login/farmer-bro.svg";
import farmer2 from "./login/weather-rafiki.svg";
import farmer3 from "./login/rice-field.svg";

// Login Slider
export const Farmer1 = farmer1;
export const Farmer2 = farmer2;
export const Farmer3 = farmer3;

// Logo
export const LogoSVG = mLogo;